<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"  >
  <p style="font-size: 20px; color: white">{{'messages.exporting' | translate}}</p>
</ngx-spinner>
<div class="main-content">
  <div class="page-content">
    <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-flex align-items-center justify-content-between">
            <h4 class="mb-0 font-size-18">
              <i class="bx bx-home-circle"></i>  {{'dashboard.welcome' | translate}}
              <app-fildariane></app-fildariane>
            </h4>
            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item"><a href="javascript: void(0);">{{'navigation.home' | translate}}</a></li>
                <li class="breadcrumb-item active"> {{'pages.myProfile' | translate}}
                  <ng-container *ngIf="profile_id==1">
                    {{'account.superAdministrator' | translate}}
                  </ng-container>
                  <ng-container *ngIf="profile_id==12">
                    {{'account.client' | translate}}
                  </ng-container>
                  <ng-container *ngIf="profile_id==6">
                    {{'account.supervisor' | translate}}
                  </ng-container>
                  <ng-container *ngIf="profile_id==14">
                    {{'users.contributor' | translate}}
                  </ng-container>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- end page title -->
      <!-- end row -->
      <div class="row">
        <div class="card col-xl-12">
          <div class="card-body">
            <h4 class="card-title mb-4">{{'common.export' | translate}}</h4>

            <div class="alert alert-success text-center" role="alert" *ngIf="successMessage">
              {{text}}.
              <button type="button" class="close" data-dismiss="alert" [attr.aria-label]="'common.close' | translate">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div>
              <div class="form-group row">
                <label class="col-md-3 col-form-label">{{'messages.selectExportData' | translate}}</label>
                <div class="col-md-9">
                  <select class="custom-select" [(ngModel)]="exportate.type" (change)="chooseType($event)">
                    <option disabled selected value="">{{'export.selectData' | translate}}</option>
                    <ng-container *ngIf="profile_id==11">
                      <ng-container *ngIf="entityType!='IP'">
                      <option value="0">{{'fields.sites' | translate}}</option>
                      </ng-container>
                      <option value="1">{{'export.course' | translate}}</option>
                      <option value="2">{{'export.sessions' | translate}}</option>
                      <option value="3">Uas</option>
                    </ng-container>

                    <ng-container *ngIf="profile_id==11 || profile_id==1 || profile_id==12 || profile_id==2 || profile_id==4 || profile_id==5  ||  profile_id==6 ||  profile_id==9 ||  profile_id==10">
                      <option value="5">{{'fields.certificate' | translate}}</option>
                      <option value="8">{{'export.subCertificates' | translate}}</option>
                      <option value="9" *ngIf="profile_id==11" >{{'export.registrationSessions' | translate}}</option>
                    </ng-container>

                    <ng-container *ngIf="profile_id==11 || profile_id==1 || profile_id==12 || profile_id==2 || profile_id==4 || profile_id==5  ||  profile_id==6 ||  profile_id==9 ||  profile_id==10 ||profile_id==13">
<!--                      <option value="7">Vérification</option>-->
                    </ng-container>
                  </select>
                </div>
              </div>
              <ng-container *ngIf="choose && choose==4">
                <div class="form-group row">
                  <label class="col-md-3 col-form-label">{{'export.selectSession' | translate}}</label>
                  <div class="col-md-9">

                    <ng-select [items]="sessions"
                               bindLabel="label_session"
                               bindValue="id_session"
                               [(ngModel)]="session_id">
                    </ng-select>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="choose && choose==5">
                <ng-container *ngIf="AllCertificats.length > 0">
                  <label>{{'export.selectCertificates' | translate}}</label>
                </ng-container>
                <div class="form-group row text-center  mx-4 mt-3 mb-3">
                     <ng-container *ngIf="AllCertificats.length === 0">
                      <div class="form-check form-check-inline col-md-6">
                        <label class="form-check-label" >{{'export.noCertifications' | translate}}</label>
                      </div>
                    </ng-container>
                  <!-- Dropdown de recherche avec multisélection (Libellé - code CK, tri alphabétique) -->
                  <ng-container *ngIf="AllCertificats.length != 0">
                    <div class="col-md-12 text-left">
                      <div class="mb-2">
                        <button type="button" class="btn btn-sm btn-outline-primary waves-effect" (click)="selectAllCertificats(true)">{{'common.selectAll' | translate}}</button>
                        <button type="button" class="btn btn-sm btn-outline-secondary waves-effect ml-2" (click)="selectAllCertificats(false)">{{'common.deselectAll' | translate}}</button>
                      </div>
                      <ng-select [items]="certificatOptions"
                                 bindLabel="label"
                                 bindValue="id"
                                 [multiple]="true"
                                 [closeOnSelect]="false"
                                 [searchable]="true"
                                 [appendTo]="'body'"
                                 [attr.placeholder]="'export.searchCertificates' | translate"
                                 [(ngModel)]="selectedCertificatIds">
                      </ng-select>
                    </div>
                  </ng-container>
                </div>
              </ng-container>
<!--              <ng-container *ngIf="choose && choose==7">-->
<!--                <div class="form-group row">-->
<!--                  <label class="col-md-3 col-form-label">Veuillez sélectionner la vérification</label>-->
<!--                  <div class="col-md-9">-->
<!--                    <select class="custom-select" (change)="chooseVerifications($event)">-->
<!--                      <option>Sélectionner la vérification à exporter</option>-->
<!--                      <option *ngFor="let verification of AllVerifications" value="{{verification.id}}">{{verification.name}}</option>-->
<!--                    </select>-->
<!--                  </div>-->
<!--                  <ng-container *ngIf="AllVerifications == 0">-->
<!--                    <div class="form-check form-check-inline col-md-6 mt-3">-->
<!--                      <label class="form-check-label" >Aucune verification n'est rattachée à votre compte ou votre site.</label>-->
<!--                    </div>-->
<!--                  </ng-container>-->
<!--                </div>-->
<!--              </ng-container>-->
              <ng-container *ngIf="choose && choose==8">
                <ng-container *ngIf="AllSubCertificats.length > 0">
                   <label class="">{{'export.selectSubCertificates' | translate}}</label>
                </ng-container>

                <div class="form-group row text-center  mx-4 mt-3 mb-3">
                  <ng-container *ngIf="AllSubCertificats.length === 0">
                    <div class="form-check form-check-inline col-md-6">
                      <label class="form-check-label" >{{'export.noSubCertifications' | translate}}</label>
                    </div>
                  </ng-container>
                  <!-- Dropdown de recherche avec multisélection (Libellé - code CK, tri alphabétique) -->
                  <ng-container *ngIf="AllSubCertificats.length != 0">
                    <div class="col-md-12 text-left">
                      <div class="mb-2">
                        <button type="button" class="btn btn-sm btn-outline-primary waves-effect" (click)="selectAllSubCertificats(true)">{{'common.selectAll' | translate}}</button>
                        <button type="button" class="btn btn-sm btn-outline-secondary waves-effect ml-2" (click)="selectAllSubCertificats(false)">{{'common.deselectAll' | translate}}</button>
                      </div>
                      <ng-select [items]="subCertificatOptions"
                                 bindLabel="label"
                                 bindValue="id"
                                 [multiple]="true"
                                 [closeOnSelect]="false"
                                 [searchable]="true"
                                 [appendTo]="'body'"
                                 [attr.placeholder]="'export.searchSubCertificates' | translate"
                                 [(ngModel)]="selectedSubCertificatIds">
                      </ng-select>
                    </div>
                  </ng-container>
                </div>
              </ng-container>
              <div class="alert alert-danger" role="alert" *ngIf="messeNotUser">
                {{'export.noLearners' | translate}}
              </div>
              <ng-container *ngIf="choose && choose!=-1">
                <div class="form-group row m-0">
                  <div class="form-group text-center">
                    <button type="button" class="btn btn-primary waves-effect waves-light" (click)="exportation()">
                      {{'common.export' | translate}}
                    </button>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
        <!-- end card -->

        <!-- end card -->
      </div>

    </div>
    <!-- end row -->
  </div>
  <!-- container-fluid -->
</div>
<!-- End Page-content -->
<app-footer></app-footer>
